/**
	* Changelog mode enum
*/
enum ChangelogMode {
	None,
	Created,
	Modified
}

export default ChangelogMode;